import { Prefix } from '../constants';
import { getVarName, hexToRgb, rgbToHsl } from '../helpers';

export const generateCustomPalette = (colors: any) => {
  const variations: string[] = [];

  for (const key in colors) {
    if (colors.hasOwnProperty(key)) {
      const baseVarName = getVarName(Prefix.color, key);

      for (let i = 0; i < colors[key].length; i++) {
        const [r, g, b] = hexToRgb(colors[key][i]);
        const [h, s, l] = rgbToHsl(r, g, b);

        variations.push(`${baseVarName}-${i + 1}: ${h}, ${s}%, ${l}%;`);
      }
    }
  }

  return variations;
};
